// extracted by mini-css-extract-plugin
export default {"masonry":"ArticleMasonry-module--masonry--2VC2S","column":"ArticleMasonry-module--column--2BKy7"};